// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFaceHappy = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M14.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3M11 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0m1 4.5c-1.224 0-2.246-.632-2.744-1.499l-1.734.998C8.392 16.01 10.091 17 12 17s3.607-.989 4.477-2.501l-1.733-.998C14.246 14.368 13.224 15 12 15" />,
    <path fillRule="evenodd" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0m-2 0a7 7 0 11-14 0 7 7 0 0114 0" />
  );
export default SvgIconFaceHappy;
